import { render, staticRenderFns } from "./viewImg.vue?vue&type=template&id=02b0a0b2&scoped=true&"
import script from "./viewImg.vue?vue&type=script&lang=js&"
export * from "./viewImg.vue?vue&type=script&lang=js&"
import style0 from "./viewImg.vue?vue&type=style&index=0&id=02b0a0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b0a0b2",
  null
  
)

export default component.exports